import {
  Users,
  Settings,
  LayoutGrid,
  Rows2,
  Plus,
  Scroll,
  BarChart,
} from "lucide-react";

export function getMenuList(pathname: string) {
  return [
    {
      groupLabel: "",
      menus: [
        {
          href: "/dashboard",
          label: "Dashboard",
          active: pathname.includes("/dashboard"),
          icon: LayoutGrid,
          submenus: [],
        },
      ],
    },
    {
      groupLabel: "Contents",
      menus: [
        {
          href: "",
          label: "Scripts",
          active: pathname.includes("/scripts"),
          icon: Scroll,
          submenus: [
            {
              icon: Rows2,
              href: "/scripts",
              label: "All Scripts",
              active: pathname === "/scripts",
            },
            {
              icon: Plus,
              href: "/scripts/new",
              label: "New Script",
              active: pathname === "/scripts/new",
            },
          ],
        },
        {
          href: "/analytics",
          label: "Analytics",
          active: pathname.includes("/analytics"),
          icon: BarChart,
          submenus: [],
        },
      ],
    },
    {
      groupLabel: "Settings",
      menus: [
        {
          href: "/profile",
          label: "Profile",
          active: pathname.includes("/profile"),
          icon: Users,
          submenus: [],
        },
        {
          href: "/account",
          label: "Account",
          active: pathname.includes("/account"),
          icon: Settings,
          submenus: [],
        },
      ],
    },
  ];
}
